import React from 'react'
import {Link, Outlet, Route, Routes, useLocation} from 'react-router-dom'
import {UsersListWrapper} from './users-list/UsersList'
import clsx from 'clsx'
import {Badge} from 'react-bootstrap'
import PatientCreate from './users-list/PatientCreate'
import {DraftWrapper} from './draft/UsersList'
import {AwaitApprovalWrapper} from './await-approval/UsersList'
import {VoidedWrapper} from './voided/UsersList'
import {ApprovedWrapper} from './approved/UsersList'
import {PartialWrapper} from './partial/UsersList'
import {CompletelyWrapper} from './completely/UsersList'
import IncomeDocumentDetailPage from '../../../components/app/IncomeDocumentDetailPage'
import IncomeDocumentPDFA5Page from '../../../components/app/IncomeDocumentPDFA5Page'

const pathTabs = [
  ['/expense-purchase-order', 'ทั้งหมด'],
  ['/expense-purchase-order/draft', 'ร่าง'],
  ['/expense-purchase-order/await-approval', 'รออนุมัติ'],
  ['/expense-purchase-order/approved', 'อนุมัติแล้ว'],
  ['/expense-purchase-order/partial', 'ออกบางส่วน'],
  ['/expense-purchase-order/completely', 'ออกครบแล้ว'],
  ['/expense-purchase-order/voided', 'ถังขยะ'],
]

const pathTabsAsset = [
  ['/expense-purchase-asset-order', 'ทั้งหมด'],
  ['/expense-purchase-asset-order/draft', 'ร่าง'],
  ['/expense-purchase-asset-order/await-approval', 'รออนุมัติ'],
  ['/expense-purchase-asset-order/approved', 'อนุมัติแล้ว'],
  ['/expense-purchase-asset-order/partial', 'ออกบางส่วน'],
  ['/expense-purchase-asset-order/completely', 'ออกครบแล้ว'],
  ['/expense-purchase-asset-order/voided', 'ถังขยะ'],
]

export const PatientTabs = ({count}: any) => {
  const location = useLocation()
  const isInExpensePurchaseOrderAssetPage = location.pathname.includes(
    'expense-purchase-asset-order'
  )
  const activeTab = location.pathname

  return (
    <div className='patient-tabs'>
      {(isInExpensePurchaseOrderAssetPage ? pathTabsAsset : pathTabs).map((item, index) => (
        <Link
          to={item[0]}
          key={index}
          className={clsx('patient-tabs__item', {
            'patient-tabs__item--active': activeTab === item[0],
          })}
        >
          <h4 className='label mb-0'>
            {item[1]}
            {!!count[index] && (
              <Badge className='ms-2' text='white' bg='dark'>
                {count[index]}
              </Badge>
            )}
          </h4>
        </Link>
      ))}
    </div>
  )
}

const ExpensePurchaseOrder = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/'
          element={
            <>
              <UsersListWrapper />
            </>
          }
        />
        <Route
          path='/draft'
          element={
            <>
              <DraftWrapper />
            </>
          }
        />
        <Route
          path='/await-approval'
          element={
            <>
              <AwaitApprovalWrapper />
            </>
          }
        />
        <Route
          path='/approved'
          element={
            <>
              <ApprovedWrapper />
            </>
          }
        />
        <Route
          path='/completely'
          element={
            <>
              <CompletelyWrapper />
            </>
          }
        />
        <Route
          path='/partial'
          element={
            <>
              <PartialWrapper />
            </>
          }
        />
        <Route
          path='/voided'
          element={
            <>
              <VoidedWrapper />
            </>
          }
        />
        <Route
          path='/create'
          element={
            <>
              <PatientCreate />
            </>
          }
        />
        <Route
          path='/:id/edit'
          element={
            <>
              <PatientCreate />
            </>
          }
        />
        <Route
          path='/:id/detail'
          element={
            <>
              <IncomeDocumentDetailPage />
            </>
          }
        />
        <Route
          path='/:id/print'
          element={
            <>
              <IncomeDocumentPDFA5Page />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default ExpensePurchaseOrder
